export const RESET = 'EXCMCONSENT_UPDATE_RESET'
export const SET_ERROR = 'EXCMCONSENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCONSENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCONSENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCONSENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCONSENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCONSENT_UPDATE_UPDATE_RETRIEVED'
